import {
    useQuery,
  } from '@tanstack/react-query'
import { AxiosResponse } from 'axios';
import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { getUser, UserResponse } from '@jconradi/tutu-porn-api-client/src/users';

export const useUser = (username: string) => {
    const { isLoggedIn, jwtData } = useContext(AuthContext);
    const [ isMe, setIsMe ] = useState(username !== undefined && jwtData?.username === username);

    useEffect(() => {
        setIsMe(username !== undefined && jwtData?.username === username);
    }, [username, jwtData]);


    const query = useQuery({
        queryKey: ['users', 'username', username],
        queryFn: async () => {
            const resp = await getUser(username);
            return resp.data;
        },
        enabled: username !== undefined
    });


    return { ...query, isMe };
}